'use strict';

/**
 * all events used by Flowplayer
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVR = exports.PORTRAIT = exports.LANDSCAPE = exports.RECOMMENDATIONS_READY = exports.VIDEO_TRACK_SELECT = exports.SET_QUALITY = exports.VIDEO_TRACKS = exports.QUALITIES = exports.REAP = exports.SOURCE = exports.VIEW_LEAVE = exports.VIEW_ENTER = exports.DURATION_CHANGE = exports.SEEKING = exports.SEEKED = exports.ENDED = exports.CAN_PLAY = exports.WAITING = exports.PLAY = exports.PLAYING = exports.PAUSE = exports.VOLUME_CHANGE = exports.LOAD_START = exports.TIME_UPDATE = exports.PROGRESS = exports.DATA = exports.METADATA = exports.FULLSCREEN_CHANGE = exports.FULLSCREEN_EXIT = exports.FULLSCREEN_ENTER = exports.SCROLL = exports.RESIZE = exports.TOUCH_CANCEL = exports.TOUCH_END = exports.TOUCH_MOVE = exports.TOUCH_START = exports.MOUSE_MOVE = exports.MOUSE_DOWN = exports.MOUSE_UP = exports.MOUSE_LEAVE = exports.MOUSE_ENTER = exports.LOAD = exports.KEYDOWN = exports.KEYUP = exports.DBL_CLICK = exports.CLICK = exports.CONTEXT_MENU = exports.ERROR = exports.RETRY = exports.MOUNT = void 0;
exports.CUEPOINT_END = exports.CUEPOINT_START = exports.CUEPOINTS = exports.CONTENT_REAL_LOAD_START = exports.BEFORE_PAUSE = exports.BEFORE_PLAY = exports.STATE = exports.CONFIG = exports.NON_RECOVERABLE_ERROR = exports.AUDIO_ONLY_SOURCE = exports.RENDER_PLUGIN = exports.WEBKIT_NEEDKEY = exports.INTERSECTIONCHANGE = exports.REMOTE_SESSION_ENDED = exports.REMOTE_SESSION_STARTED = exports.PLUGIN_REGISTERED = exports.SEEK_CANCEL = exports.SEEK_QUEUED = exports.RECOVER = exports.LIVE = void 0;
exports.MOUNT = "mount", 
/**
 * @public
 */
exports.RETRY = "retry", 
// native events that flowplayer use
/**
 * @public
 */
exports.ERROR = "error", 
/**
 * @public
 */
exports.CONTEXT_MENU = "contextmenu", 
/**
 * @public
 */
exports.CLICK = "click", 
/**
 * @public
 */
exports.DBL_CLICK = "dblclick", 
/**
 * @public
 */
exports.KEYUP = "keyup", 
/**
 * @public
 */
exports.KEYDOWN = "keydown", 
/**
 * @public
 */
exports.LOAD = "load", 
/**
 * @public
 */
exports.MOUSE_ENTER = "mouseenter", 
/**
 * @public
 */
exports.MOUSE_LEAVE = "mouseleave", 
/**
 * @public
 */
exports.MOUSE_UP = "mouseup", 
/**
 * @public
 */
exports.MOUSE_DOWN = "mousedown", 
/**
 * @public
 */
exports.MOUSE_MOVE = "mousemove", 
/**
 * @public
 */
exports.TOUCH_START = "touchstart", 
/**
 * @public
 */
exports.TOUCH_MOVE = "touchmove", 
/**
 * @public
 */
exports.TOUCH_END = "touchend", 
/**
 * @public
 */
exports.TOUCH_CANCEL = "touchcancel", 
/**
 * @public
 */
exports.RESIZE = "resize", 
/**
 * @public
 */
exports.SCROLL = "scroll", 
/**
 * @public
 */
exports.FULLSCREEN_ENTER = "fullscreenenter", 
/**
 * @public
 */
exports.FULLSCREEN_EXIT = "fullscreenexit", 
/**
 * @public
 */
exports.FULLSCREEN_CHANGE = "fullscreenchange", 
/**
 * @public
 * general video events flowplayer uses internally
 *  https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events
 */
exports.METADATA = "loadedmetadata", 
/**
 * @public
 */
exports.DATA = "loadeddata", 
/**
 * @public
 */
exports.PROGRESS = "progress", 
/**
 * @public
 */
exports.TIME_UPDATE = "timeupdate", 
/**
 * @public
 */
exports.LOAD_START = "loadstart", 
/**
 * @public
 */
exports.VOLUME_CHANGE = "volumechange", 
/**
 * @public
 */
exports.PAUSE = "pause", 
/**
 * @public
 */
exports.PLAYING = "playing", 
/**
 * @public
 */
exports.PLAY = "play", 
/**
 * @public
 */
exports.WAITING = "waiting", 
/**
 * @public
 */
exports.CAN_PLAY = "canplay", 
/**
 * @public
 */
exports.ENDED = "ended", 
/**
 * @public
 */
exports.SEEKED = "seeked", 
/**
 * @public
 */
exports.SEEKING = "seeking", 
/**
 * @public
 */
exports.DURATION_CHANGE = "durationchange", 
/**
 * @public
 * when a player enters the viewpoint
 */
exports.VIEW_ENTER = "viewenter", 
/**
 * @public
 * when a player leaves the viewport
 */
exports.VIEW_LEAVE = "viewleave", 
/**
 * @public
 * emitted when a valid source is found prior to mounting
 */
exports.SOURCE = "src", 
/**
 * @public
 * emitted when it is safe to clean up a fp instance
 */
exports.REAP = "reap", 
/**
 * @public
 * emitted whenever a list of qualities has been made available
 *  when index 0 is the highest quality and index 0+N is the lowest
 */
exports.QUALITIES = "qualities", 
/**
 * @public
 * emitted whenever multiple video tracks are detected
 */
exports.VIDEO_TRACKS = "videoTracks", 
/**
 * @public
 * @deprecated please use Qsel.events.SET_QUALITY
 */
exports.SET_QUALITY = "quality:set", 
/**
 * @public
 * emitted when a video track is selected
 */
exports.VIDEO_TRACK_SELECT = "tracks:video:select", 
/**
 * @deprecated please use Endscreen.events.RECOMMENDATIONS_READY / flowplayer.endscreen.events.RECOMMENDATIONS_READY
 **/
/**
 * @public
 */
exports.RECOMMENDATIONS_READY = "recommendationsready", 
/**
 * @public
 */
exports.LANDSCAPE = "landscape", 
/**
 * @public
 */
exports.PORTRAIT = "portrait", 
/**
 * @public
 * when the player has started playing dvr content
 */
exports.DVR = "dvr", 
/**
 * @public
 * when src is a livestream
 */
exports.LIVE = "live", 
/**
 * @public
 * emitted when an Error recovery is attempted
 */
exports.RECOVER = "recover", 
/**
 * @internal
 */
exports.SEEK_QUEUED = "seek:queued", 
/**
 * @internal
 */
exports.SEEK_CANCEL = "seek:cancel", 
/**
 * @internal
 */
exports.PLUGIN_REGISTERED = "plugin:registered", 
/**
 * @internal
 */
exports.REMOTE_SESSION_STARTED = "remotesession:started", 
/**
 * @internal
 */
exports.REMOTE_SESSION_ENDED = "remotesession:ended", 
/**
 * @internal
 */
exports.INTERSECTIONCHANGE = "intersectionchange", 
/**
 * @internal
 */
exports.WEBKIT_NEEDKEY = "webkitneedkey", 
/**
 * @internal
 */
exports.RENDER_PLUGIN = "renderplugin", 
/**
 * @internal
 */
exports.AUDIO_ONLY_SOURCE = "audioonlysource", 
/**
 * @internal
 *  error that is fatal in a sense where nothing can be done and
 * player should be destroyed
 */
exports.NON_RECOVERABLE_ERROR = "error:fatal", 
/**
 * @internal
 * emitted whenever config is changed
 */
exports.CONFIG = "config", 
/**
 * @internal
 * Player (UI) state changed
 */
exports.STATE = "state", 
/**
 * @internal
 * Custom video events
 */
exports.BEFORE_PLAY = "beforeplay", 
/**
 * @internal
 */
exports.BEFORE_PAUSE = "beforepause", 
/**
 * @internal
 * Emitted to normalize that content has started loading across various browsers & plugin combinations for analytics timing
 */
exports.CONTENT_REAL_LOAD_START = "content:loadstart", 
/**
 * @public
 * @deprecated
 * cuepoints parsing is asynchronous
 * you cannot rely on them existing until
 * this event is emitted
 */
exports.CUEPOINTS = "cuepoints", 
/**
 * @public
 * @deprecated
 * when a cuepoint is active
 */
exports.CUEPOINT_START = "cuepointstart", 
/**
 * @public
 * @deprecated
 *  when a cuepoint becomes inactive
 */
exports.CUEPOINT_END = "cuepointend";
